import { setRangeMax } from './helpers';

export const setBedroomsCountMax = setRangeMax('bedroom_total');
